(function () {
  "use strict";

  // Recovered from the live theme (this file was missing from the local
  // export) and fixed: COMPARE_PAGE pointed at "/pages/compare", but the
  // merchant's actual Compare page lives at "/pages/compare-phones" - so
  // every "Compare" click anywhere on the site except from inside that page
  // itself (where window.__uhCompare.add short-circuits this file) was
  // sending customers to a 404.
  var COMPARE_PAGE = "/pages/compare-phones";
  var MAX_COMPARE = 3;
  var STORAGE_KEY = "uh_compare_ids";

  function getStored() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
    } catch (e) {
      return [];
    }
  }

  function setStored(ids) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {}
  }

  function buildCompareUrl(ids) {
    return COMPARE_PAGE + (ids.length ? "?compare=" + ids.join(",") : "");
  }

  function wireButtons() {
    document.querySelectorAll("[data-compare-id]").forEach(function (btn) {
      if (btn.dataset.compareWired) return;
      btn.dataset.compareWired = "1";
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        addAndNavigate(parseInt(btn.dataset.compareId, 10));
      });
    });

    document.querySelectorAll(".single-product-wrap").forEach(function (wrap) {
      var productId = parseInt(wrap.dataset.productId, 10);
      if (!productId) return;
      wrap
        .querySelectorAll('a[href="#"][title="Compare Product"], a[href="#"][aria-label*="Compare"]')
        .forEach(function (link) {
          if (link.dataset.compareWired) return;
          link.dataset.compareWired = "1";
          link.addEventListener("click", function (e) {
            e.preventDefault();
            addAndNavigate(productId);
          });
        });
    });
  }

  function addAndNavigate(productId) {
    if (!productId || isNaN(productId)) return;

    // Already on the compare page: its own script exposes this hook and can
    // add the product in place, no navigation needed.
    if (window.__uhCompare && typeof window.__uhCompare.add === "function") {
      window.__uhCompare.add(productId);
      return;
    }

    var ids = getStored();
    if (ids.indexOf(productId) === -1) {
      ids.push(productId);
      if (ids.length > MAX_COMPARE) ids = ids.slice(-MAX_COMPARE);
      setStored(ids);
    }
    window.location.href = buildCompareUrl(ids);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", wireButtons);
  } else {
    wireButtons();
  }
  document.addEventListener("shopify:section:load", wireButtons);

  window.__uhCompareInit = { addAndNavigate: addAndNavigate };
})();